// src/features/riskmize/IncidentsLayerControl.jsx
//
// Top-right cluster toggle for the Riskmize incidents layer. Hides itself
// entirely when the org doesn't have the riskmize module enabled via the
// canonical feature-flag mechanism (`useFeatures().riskmize`), so non-Riskmize
// customers never see the button. Sizing matches HeatmapControl/RouteControl
// (h-9 pill with shadow + glass bg).
import { useDispatch, useSelector } from 'react-redux';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { riskmizeActions } from '@/store';
import useFeatures from '@/hooks/useFeatures';

export default function IncidentsLayerControl() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { riskmize } = useFeatures();
  const layerEnabled = useSelector((s) => s.riskmize.layerEnabled);

  if (!riskmize) return null;

  return (
    <button
      type="button"
      onClick={() => dispatch(riskmizeActions.toggleLayer())}
      aria-pressed={layerEnabled}
      className={`h-9 px-3.5 text-xs font-semibold rounded-xl flex items-center gap-2 transition-all shadow-md ${
        layerEnabled
          ? 'bg-rose-600 text-white shadow-rose-500/25'
          : 'bg-white/90 text-slate-600 hover:bg-white border border-slate-200/80 dark:bg-slate-800/90 dark:text-slate-300 dark:border-slate-700/80 dark:hover:bg-slate-800'
      }`}
      style={{ backdropFilter: 'blur(12px)' }}
      title={t('riskmize.layerToggle', 'Incidents')}
    >
      <ShieldAlert className="w-3.5 h-3.5" />
      {t('riskmize.layerToggle', 'Incidents')}
    </button>
  );
}
